<div class="modal-column" *ngIf="isValid && loaded">
  <div class="log-in-form-block">
    <form (ngSubmit)="resetPassword()" [formGroup]="form" novalidate>
      <h5>Reset password</h5>
      <p class="subtext">Enter new password.</p>
      <div class="spacer-10"></div>
      <input type="hidden" formControlName="token">
      <ng-container *ngIf="secured && !question">
        <app-form-select formControlName="question" title="{{ 'default.question' | translate }}" [options]="qOptions"></app-form-select>
        <app-form-input formControlName="answer" type="text" title="{{ 'default.answer' | translate }}" placeholder="{{ 'default.answer' | translate }}"></app-form-input>
      </ng-container>
      <div class="ui-input-wrap" *ngIf="secured && question">
        <app-form-input formControlName="answer" type="text" title="{{ getQuestion(question) }}" placeholder="{{ 'default.answer' | translate }}"></app-form-input>
      </div>
      <app-form-input formControlName="password" type="password" title="New password" data-id="modalReset-password-input"></app-form-input>
      <app-form-input formControlName="passwordConfirmation" type="password" title="Repeat new password" data-id="modalReset-passwordconfirmation-input"></app-form-input>
      <app-form-button type="submit" class="primary full-width" [disabled]="!form.valid" data-id="modalReset-change-button">Change password</app-form-button>
    </form>
  </div>
  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup" data-id="modalReset-closer-href">
    <i class="fal fa-times"></i>
  </a>
</div>
<div class="modal-column" *ngIf="!isValid && loaded">
  <h2>Error</h2>
  <p>Password reset token is invalid or expired.</p>
  <app-form-button class="primary" [routerLink]="['/', {outlets: { modal: null } } ]" data-id="modalReset-ok-button">
    Ok
  </app-form-button>
  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup" data-id="modalReset-close-href">
    <i class="fal fa-times"></i>
  </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/reset-password/reset-password-modal.template.html